// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3L70H","header":"MergedInvoice_header__1_X8I"};